import { render } from "./Spaces.vue?vue&type=template&id=1d791c54"
import script from "./Spaces.vue?vue&type=script&lang=js"
export * from "./Spaces.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__